import { acceptHMRUpdate, defineStore } from "pinia";
import { reactive, toRefs } from "vue";

import featureFlagsService from "@/common/api/feature-flags.service";
import type { FeatureFlags } from "@/common/api/types";

export const useFeatureFlagsStore = defineStore("featureFlags", () => {
  const state = reactive<FeatureFlags>({
    wordCompletion: true,
    smartComplete: true,
    voiceSearch: true
  });

  const setFeatureFlags = (flags: Partial<FeatureFlags>) => {
    Object.assign(state, { ...flags });
  };

  const refreshFeatureFlags = async () => {
    setFeatureFlags((await featureFlagsService.featureFlags()).data.data.featureFlags);
  };

  return {
    ...toRefs(state),

    setFeatureFlags,
    refreshFeatureFlags
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useFeatureFlagsStore, import.meta.hot));
}
